import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch, faClipboardList } from '@fortawesome/free-solid-svg-icons';

const ParticipantGuestRow = ({ participantId, onOpenGuest }) => {
  const API_URL = process.env.REACT_APP_API_URL || '';
  const [guests, setGuests] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchGuests = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(`${API_URL}/ems/participants/${participantId}/guests`);
      setGuests(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to load guests');
    } finally {
      setLoading(false);
    }
  }, [API_URL, participantId]);

  useEffect(() => {
    fetchGuests();
  }, [fetchGuests]);

  return (
    <div
      style={{
        background: '#fafafa',
        padding: '12px 24px',
        borderTop: '1px solid #e0e0e0',
        borderBottom: '1px solid #e0e0e0',
      }}
    >
      {loading ? (
        <div style={{ color: '#666', fontSize: '13px' }}>
          <FontAwesomeIcon icon={faCircleNotch} spin /> Loading guests…
        </div>
      ) : error ? (
        <div className="text-danger small">{error}</div>
      ) : !guests || guests.length === 0 ? (
        <div style={{ color: '#888', fontStyle: 'italic', fontSize: '13px' }}>
          No guests
        </div>
      ) : (
        <table className="table table-sm mb-0" style={{ background: 'transparent' }}>
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th style={{ width: '120px' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {guests.map((g) => (
              <tr key={g._id}>
                <td>{g.firstName || '—'}</td>
                <td>{g.lastName || '—'}</td>
                <td>{g.email || '—'}</td>
                <td>
                  <button
                    type="button"
                    className="btn btn-sm btn-link p-0"
                    onClick={() => onOpenGuest(g._id)}
                    title="Edit forms"
                  >
                    <FontAwesomeIcon icon={faClipboardList} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ParticipantGuestRow;
